import { addDays } from "date-fns";
import { IAWBInitialState } from "../../../types/operations/awbInterface";
import { AWBActionTypes, AWBActions } from "../../actionTypes/operations/AwbActionTypes";

const initialState: IAWBInitialState = {
  customer: {
    label: "Select Option",
    value: 0,
  },
  vendor: {
    label: "Select Option",
    value: 0,
  },
   branch: {
    label: "Select Option",
    value: 0,
  },
  awbState: "",
  bookingDateRange: [
    {
      startDate: addDays(new Date(), -15),
      endDate: addDays(new Date(), 15),
      key: "selection",
    },
  ],
};

export default function awbReducer(state = initialState, action: AWBActionTypes): IAWBInitialState {
  switch (action.type) {
    case AWBActions.SET_CUSTOMER:
      return {
        ...state,
        customer: action.payload,
      };

    case AWBActions.SET_VENDOR:
      return {
        ...state,
        vendor: action.payload,
      };

    case AWBActions.SET_BRANCH:
     return {
       ...state,
       branch: action.payload,
    };

    case AWBActions.SET_AWB_STATE:
      return {
        ...state,
        awbState: action.payload,
      };

    case AWBActions.SET_BOOKING_DATE_RANGE:
      return {
        ...state,
        bookingDateRange: action.payload,
      };

    default:
      return state;
  }
}
